/**
* Copyright Zendesk, Inc.
*
* Use of this source code is governed under the Apache License, Version 2.0
* found at http://www.apache.org/licenses/LICENSE-2.0.
*/
import React__default from 'react';
import styled from 'styled-components';
import { em } from 'polished';
import { getColorV8, DEFAULT_THEME } from '@zendeskgarden/react-theming';
import SvgChevronRightStroke from '../node_modules/@zendeskgarden/svg-icons/src/12/chevron-right-stroke.svg.js';

const ValidChevronIcon = props => {
  const {
    theme,
    ...validProps
  } = props;
  return React__default.createElement(SvgChevronRightStroke, validProps);
};
const StyledChevronIcon = styled(ValidChevronIcon).attrs({
  role: 'presentation',
  'aria-hidden': 'true'
}).withConfig({
  displayName: "StyledChevronIcon",
  componentId: "sc-9r9qrm-0"
})(["transform:", ";margin:0 ", ";color:", ";"], props => props.theme.rtl && `rotate(180deg);`, props => em(props.theme.space.base, props.theme.fontSizes.md), props => getColorV8('neutralHue', 600, props.theme));
StyledChevronIcon.defaultProps = {
  theme: DEFAULT_THEME
};

export { StyledChevronIcon };
